
<!-- footer start -->
<footer class="footer"> © 2026, Sri Chaitanya Group. All Rights Reserved.</footer>
<!--footer end  -->